import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-chart-paginator',
  templateUrl: './chart-paginator.component.html',
  styleUrls: ['./chart-paginator.component.scss'],
  standalone: false
})
export class ChartPaginatorComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true, read: ViewContainerRef }) paginator: any;
  @Input() public totalPoints: number = 0;
  @Output() pagChange = new EventEmitter<any>();

  public divElem: any;
  public pageSize: number = 10;
  public oriPageSize: number = 10;
  public pageIndex: number = 0;
  public paginationNo: number = 0;
  public paginationLastNo: number = 1;
  public itemsPerPageLabel: string = '';
  public matPageSize: number = 10;
  public pageNoArr: Array<any> = [];
  public pageNoArrFilter: Array<any> = [];
  public pageNoCtrl = new FormControl('1');

  constructor() { }

  ngOnInit(): void {
    this.generatePagination();
  }

  public paginationCalculation(allPoints: number): void {
    const qu: any = allPoints / 300;
    this.paginationLastNo = Math.ceil(qu);
    this.pageSize = qu < this.oriPageSize ? this.paginationLastNo : this.oriPageSize;
    const last = Math.ceil(this.paginationLastNo / 100);
    this.pageNoArr = [];
    this.pageNoArrFilter = [];
    const lst: number = Math.ceil(this.paginationLastNo / 10);
    for (let i = 1; i <= lst; i++) {
      this.pageNoArr.push(i + '');
      this.pageNoArrFilter.push(i + '');
    }
    this.pageNoCtrl.setValue('1');
  }

  public generatePagination(): void {
    this.paginationCalculation(this.totalPoints);
    const para = this.paginator?.element?.nativeElement?.querySelector('.mat-mdc-paginator-range-actions');
    const bt = this.paginator?.element?.nativeElement?.querySelector('.mat-mdc-paginator-range-actions button[type="button"]:nth-child(3)');
    this.divElem = document.createElement('div');
    this.divElem.className += 'pag-wrapper';
    para?.insertBefore(this.divElem, bt)
    this.drawNumbers();
  }

  public drawNumbers(): void {
    const l: number = Math.ceil((this.paginationLastNo * this.oriPageSize) / this.oriPageSize);
    this.divElem.innerHTML = '';
    for (let i = 1; i <= this.pageSize; i++) {
      const span = document.createElement('span');
      const n: number = this.paginationNo * this.oriPageSize + i;
      const c: string = n === this.pageIndex + 1 ? 'selected' : '';
      span.className += `numbs ${c}`;
      span.innerHTML = `${n}`;
      if (n <= l) {
        this.divElem.appendChild(span);
        this.pageIndexClick = this.pageIndexClick.bind(this);
        span.addEventListener("click", this.pageIndexClick);
      }
    }
  }

  public pageIndexClick(evt: any) {
    const num = parseInt(evt.srcElement.innerHTML) - 1;
    this.pageIndex = num;
    this.drawNumbers();
    this.pageNoCtrl.setValue((num + 1).toString());
    this.pagChange.emit(num + 1);
    const ind: number = Math.floor((num) / 10) + 1;
    this.pageNoCtrl.setValue(ind.toString());
  }

  public pageChange(event: any): void {
    const que: any = event.pageIndex / this.oriPageSize;
    this.pageIndex = event.pageIndex;
    this.paginationNo = parseInt(que);
    this.matPageSize = this.oriPageSize;
    this.drawNumbers();
    const ind: number = Math.floor((event.pageIndex) / 10) + 1;
    this.pageNoCtrl.setValue(ind.toString());
    this.pagChange.emit(event.pageIndex + 1);
  }

  public pageNoChange(): void {
    const num: any = parseInt(this.pageNoCtrl.value) - 1;
    this.pageIndex = num * 10;
    this.paginationNo = num;
    this.drawNumbers();
    this.pagChange.emit(num * 10 + 1);
  }

}
